import {
	PointsMaterial,
	Color,
	BufferGeometry,
	Float32BufferAttribute,
	Points
} from 'three';
import {
	to as convert,
	P3_Linear,
	ColorSpace
} from "../node_modules/colorjs.io/src/index-fn.js";
import reorderArray from './reorderArray.js';

const linearP3 = ColorSpace.register(P3_Linear);


// take points in one colorspace and plot them in another colorspace
// mostly used for debugging, construction

// takes points = [ [0,0,0], [0, 0.1, 0.2], ...etc ] (among other things)
// returns [ THREE.Points, THREE.points, ...etc ] with length of input points
// and
// - points assigned color based on input space
// - point positions mapped to context space

export default function pointsToContextSpace(
	pointsSpace, // ColorSpace
	contextSpace, // ColorSpace
	contextChannelsToXYZ_Map, // Array e.g. [1,0,2] for L->y, a->x, b->z
	pointSize, // Number e.g. 0.1
	points // Array<n> of Array<3>s, e.g. [ [0,0,0], [0, 0.1, 0.2], ...etc ]
) {

	return points.map( ( point ) => {

		// Make a new material with a new color for each point
		const material = new PointsMaterial( {
			// assumes we are outputting to a Linear P3 canvas,
			// color managed by three.js
			color: new Color(
				...convert(
					{ 
						space: pointsSpace,
						coords: point
					}, 
					linearP3
				).coords,
			),
			sizeAttenuation: true,
			size: pointSize
		} );

		// convert our one lil point to the contextSpace
		// aside: would it be faster to group them all into one THREE.Points object??
		// this is for debugging and construction so I don't really care I guess
		const vertex = reorderArray(
			convert( { space: pointsSpace, coords: point }, contextSpace ).coords,
			contextChannelsToXYZ_Map
		);

		const geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( vertex, 3 ) );

		// tada!
		return new Points( geometry, material );

	} );

}
